import { useState } from "react";
import { Button } from "reactstrap";

import ListItem from "../../../components/CRM/ListItem";
import useDeleteSession from "../../../api/api-hooks/auth/sessions/useDeleteSession";
import useSessions from "../../../api/api-hooks/auth/sessions/useSessions";
import useLogout from "../../../api/api-hooks/auth/useLogout";
import { AppConfirm } from "../../../utils/PopupUtil";
import AppTablePagination from "../../../components/AppTable/AppTablePagination";

const AccountSessions = () => {
  const [queryPagination, setQueryPagination] = useState({
    Pagination: { Count: 25, Page: 1 },
  });
  const { sessions, pagination, sessionsLoading } =
    useSessions(queryPagination);

  const { logout } = useLogout();
  const { deleteSession } = useDeleteSession();

  const handleDeleteSession = async (
    sID: string,
    isCurrentSession?: boolean
  ) => {
    // Check if the session is the user's current session.
    if (isCurrentSession) {
      const result = await AppConfirm({
        title: "Logout Warning",
        text: "This is your current session, and revoking it will log you out.",
        confirmButtonText: "Logout",
      });

      // Logout user on confirm (logout function deletes session.)
      if (result.isConfirmed) logout({});

      return;
    }

    deleteSession(sID);
  };

  return (
    <div>
      <h3 className="mb-0">Active Sessions</h3>
      <div>
        <small>
          This is a list of the devices that have logged into your account.
          Revoke any sessions that you do not recognize.
        </small>
      </div>
      <hr className="mt-2 mb-3"></hr>
      {sessionsLoading ? (
        <>
          <ListItem loading={true} />
          <ListItem loading={true} />
        </>
      ) : (
        <>
          {sessions.map((session) => {
            if (!session.id) return null;

            const optionsButton = (
              <Button
                className="btn-icon-only"
                color="danger"
                size="sm"
                outline
                onClick={() =>
                  handleDeleteSession(session.id!, session?.IsCurrentSession)
                }
              >
                <i className="mdi mdi-close" />
              </Button>
            );

            const title = session?.LocationFound
              ? `${session.City}, ${session.State} ${session.Country}`
              : "Unknown Location";

            const subTitle = session?.IsCurrentSession
              ? `Your current session (${session.Ip})`
              : `(${session.Ip})`;

            return (
              <ListItem
                key={session.id}
                title={title}
                subTitle={subTitle}
                icon="mdi-earth"
                optionsButton={optionsButton}
              />
            );
          })}
          <AppTablePagination
            records={sessions}
            pagination={pagination}
            query={queryPagination}
            setQuery={setQueryPagination}
            loading={sessionsLoading}
            module={{ Name: "Sessions" }}
          />
        </>
      )}
    </div>
  );
};

export default AccountSessions;
